'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z' });

var DesktopWindows = function DesktopWindows(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

DesktopWindows = (0, _pure2.default)(DesktopWindows);
DesktopWindows.muiName = 'SvgIcon';

exports.default = DesktopWindows;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/DesktopWindows.js
// module id = 2307
// module chunks = 0